import ShareModal from './ShareModal';
import { closeSharingDialog, openSharingDialog } from '../actions/internalActions';
import getStore from '../store/store';
import { SharingDialogResponse } from '../types/SharingDialogResponse';
import { getDefaultPeoplePickerProvider } from '../utils/getDefaultPeoplePickerProvider';
import { getDefaultSharingProvider } from '../utils/getDefaultSharingProvider';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

let sharingDialogDiv;

export default async function showSharingDialog(
    resolve: (result: SharingDialogResponse) => void,
    reject: () => void,
    webUrl: string,
    canonicalUrl: string,
    shareId?: string
) {
    if (!sharingDialogDiv) {
        // As we can have only one sharing dialog open at a time so we only create the
        // DOM element once and reuse that.
        sharingDialogDiv = document.createElement('div');
        sharingDialogDiv.id = 'sharingDialog';
        document.body.appendChild(sharingDialogDiv);
    }
    const sharingDialogStore = getStore();

    const peoplePickerProvider = await getDefaultPeoplePickerProvider(webUrl);
    const sharingProvider = await getDefaultSharingProvider(webUrl, canonicalUrl);

    const shareProps = {
        peoplePickerProvider: peoplePickerProvider,
        sharingProvider: sharingProvider,
        shareId: shareId,
    };

    function onDismiss(result?: SharingDialogResponse) {
        closeSharingDialog();
        if (result) {
            resolve(result);
            return;
        }

        reject();
    }

    ReactDOM.render(
        <ShareModal
            shareProps={shareProps}
            sharingDialogStore={sharingDialogStore}
            onDismiss={onDismiss}
        />,
        sharingDialogDiv
    );
    openSharingDialog();
}
